// extracted by mini-css-extract-plugin
export default {"container":"nGl8I"};